"use client"
import React,{useEffect} from 'react';
import * as config from '../../../next.config.js'
import lottie from 'lottie-web';
import style from "../../../styles/mystyle.module.css";
export default function Loading({start,id}) {
  const lottieDiv = React.useRef()
    useEffect(() => {
  // console.log("start===========>",start)
        // setTimeout(()=>{

          let instance= lottie.loadAnimation({
            container: lottieDiv.current,
            renderer: "svg",
            loop: true,
            autoplay: false,
            path: `${config["basePath"]}/json/loading.json`,
            rendererSettings: {
                className:style.loadingJSON
            }
          });
          instance.play()
          return()=>  instance.destroy()
        // },1000)
          

    }, []);
  return (
    <>
    <div ref={lottieDiv} className='flex justify-center text-center'></div>
    </>
  );
}
